/**
 * CSRF Token Utility
 *
 * Provides a centralized way to retrieve the CSRF token from cookies.
 * Laravel automatically sets the XSRF-TOKEN cookie which can be used
 * for CSRF protection in AJAX requests.
 */

/**
 * Gets a cookie value by name
 * @param name - The name of the cookie to retrieve
 * @returns The decoded cookie value or null if not found
 */
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Gets the CSRF token from the XSRF-TOKEN cookie
 * @returns The CSRF token string or empty string if not found
 */
export function getCSRFToken(): string {
  return getCookie('XSRF-TOKEN') || '';
}
